module.exports = __webpack_public_path__ + "976474c39d6a0f058b58dc47ff442790.svg";